import type { IPolicy } from './policy';
import type { IRole } from './role';
import { AuthUser } from '@aws-amplify/auth';

export interface AccountComponents {
  affiliation_code: string;
  first_name: string;
  last_name: string;
  screen_name?: string;
  phone_number: string;
  reportals: {
    enabled: boolean;
    privileged_reports_enabled: boolean,
    privileged_reports_id: string,
  };
}

export interface AccountAuthentication {
  security_authentication_via_google_enabled: boolean;
  security_authentication_via_microsoft_enabled: boolean;
  security_authentication_via_apple_enabled: boolean;
  security_authentication_via_rhs_workspace_sso_enabled: boolean;
  security_authentication_mfa_required: boolean;
  enable_feature_request: boolean;
}

export interface IAccount {
  id: string;
  alias: string;
  lifecycle_state: string;
  archived: boolean;
  settings: AccountAuthentication;
  components: AccountComponents;
  tags?: Array<Record<string, unknown>>;
  devices: Array<Record<string, unknown>>;

  lifecycle_state_id: string;
  created_at: number;
  updated_at: number;

  role_ids: Array<IRole>;
  group_ids: Array<string>;
  permission_boundarie_ids: Array<IPolicy>;
}
export const defaultAccount: IAccount = {
  archived: false,
  alias: '',
  settings: {
    security_authentication_via_google_enabled: false,
    security_authentication_via_microsoft_enabled: false,
    security_authentication_via_apple_enabled: false,
    security_authentication_via_rhs_workspace_sso_enabled: false,
    security_authentication_mfa_required: false,
    enable_feature_request: false,
  },
  components: {
    affiliation_code: '',
    first_name: '',
    last_name: '',
    phone_number: '',
    reportals: {
      enabled: false,
      privileged_reports_enabled: false,
      privileged_reports_id: ""
    },
  },
  id: '',
  tags: [],
  devices: [],
  created_at: 0,
  updated_at: 0,
  lifecycle_state_id: '',
  lifecycle_state: '',
  role_ids: [],
  group_ids: [],
  permission_boundarie_ids: [],
};
export interface PrincipalAttributes {
  sub: string;
  email: string;
  email_verified: string;
  name: string;
  updated_at: string;
}
export interface CognitoUserExt extends AuthUser {
  attributes: PrincipalAttributes;
  username: string;
}

/**
 * Model used in Internal Chat.
 */
export interface IOnlineUser {
  id: string;
  display_name: string;
  online: boolean;
  conversation_id?: string;
  unReadMessagesCount?: number;
}
